module.exports = __webpack_public_path__ + "img/Operatore-automazione-SF-041.f0255d25.jpg";